import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/174/components/features/cases/OldComponents/cases/rgs/index.js");
